import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://bwestudios.com';

/**
 * Hook to dynamically update the canonical URL meta tag based on current route.
 * This ensures each page has the correct canonical URL for SEO.
 */
export const useCanonicalUrl = () => {
  const location = useLocation();

  useEffect(() => {
    const canonicalUrl = `${BASE_URL}${location.pathname}`;
    
    // Find existing canonical link or create one
    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    
    link.href = canonicalUrl;

    // Also update Open Graph URL
    let ogUrl = document.querySelector('meta[property="og:url"]') as HTMLMetaElement;
    if (ogUrl) {
      ogUrl.content = canonicalUrl;
    }

    // Update Twitter URL
    let twitterUrl = document.querySelector('meta[name="twitter:url"]') as HTMLMetaElement;
    if (twitterUrl) {
      twitterUrl.content = canonicalUrl;
    }
  }, [location.pathname]);
};
